import React, { useState } from "react";
import { useMutation } from "@apollo/client";

import "./style.scss";
import { UPDATE_FAVORITE } from "../../schemas/favorite";

export const Notes = ({ item, defaultNotes, parentWidget, labels, setAddToFavNotes }) => {
  const [notes, setNotes] = useState({
    input1: "",
  });
  const [  updateFavorite,{ data: favoriteDataInfo, error: favoriteErrorInfo },] = useMutation(UPDATE_FAVORITE, {
    fetchPolicy: "no-cache",
  });
  
  const handleChange = (field, target) => {
    setNotes((prevState) => ({ ...prevState, [field]: target.value ?? "" }));
    if ( setAddToFavNotes ) {
      setAddToFavNotes(target.value);
    }
    updateFavorite({
      variables: {
        programInfo: {
          notes: target.value,
          nid: Number(item.nid),
          langcode: item.langcode,
          mark:""
        }
      },
    });
  };
  
  return (
    <div className={`notes ${parentWidget}`}>
      <p aria-label={labels.notes_header} className={`label ${parentWidget}`} >
        {labels.notes_header}
      </p>
      <textarea className={parentWidget}
        type="textarea"
        name="textValue"
        maxLength="120"
        onChange={(e) => handleChange("input1", e.target)}
        defaultValue={defaultNotes}
      />
    </div>
  );
};
